document.addEventListener("DOMContentLoaded", function () {
  let swipers = document.querySelectorAll(".swiper");
  if (!swipers) return;

  swipers.forEach(function (swiper) {

    new Swiper(swiper, {
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
        type: 'bullets',
      },
    });
  });
});
